module.exports = __webpack_public_path__ + "img/About_ys_big_5.25890044.jpg";